import { UserRequestType } from "../enums/global.enums";
import { DatabaseRecord } from "../repos/table.repo";

export interface UserRequestModel extends DatabaseRecord {
    code?: string;
    name: string;
    requestType: UserRequestType | string;
    address: string;
    phone: string;
    description: string;
    status: string;
    location?: string | null;
    severity?: "minor" | "moderate" | "severe" | null;
    waterUserId?: string | null;
    customDescription?: string | null;
    expectedResolutionTime?: string | null;
    resolutionSummary?: string | null;
    createdAt?: string;
    updatedAt?: string;
    createdBy: string;
    updatedBy?: string | null;
    userId: string;
    waterFactoryId: string;
}

export interface UserRequestStatusHistory {
    id: string;
    userRequestId: string;
    oldStatus: string | null;
    newStatus: string;
    description: string;
    createdAt: string;
    createdBy: string;
}

export interface UserRequestDetailResponse {
    request: UserRequestModel;
    statusHistory: UserRequestStatusHistory[];
    attachments: Array<{
        id: string;
        name: string;
        path: string;
        objectType: string;
        referenceId: string;
        createdAt: string;
    }>;
    contract: {
        id: string;
        code: string;
        name: string;
        address: string;
    } | null;
}

export class UserRequestModelFactory {
    static getEmpty(): UserRequestModel {
        return {
            id: "",
            code: "",
            name: "",
            requestType: "",
            address: "",
            phone: "",
            description: "",
            status: "",
            location: null,
            severity: null,
            waterUserId: null,
            customDescription: null,
            expectedResolutionTime: null,
            resolutionSummary: null,
            createdBy: "",
            updatedBy: null,
            userId: "",
            waterFactoryId: ""
        };
    }
}